
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'VideoHeroSection',
  props: {
    headline: {
      type: String,
      required: true,
    },
    subheadline: {
      type: String,
      default: '',
    },
    videoUrl: {
      type: String,
      required: true,
    },
    contentPosition: {
      type: String,
      default: 'center',
      validator: (value: string) => ['center', 'bottom-center'].includes(value),
    },
  },
});
